<template>
  <div>
    <div class="row justify-content-center align-items-center login-top">
      <div class="col-lg-3 p-0 d-none d-lg-block">
        <div class="log-pic">
          <img src="../assets/images/login.png" alt>
        </div>
      </div>
      <div class="col-lg-3 p-lg-0">
        <div class="login">
          <img class="log-logo" src="../assets/images/logo-innovare-dark.png" alt>
          <div
            class="log-text"
          >Seja bem-vindo ao sistema de suporte da InnovareTI.</div>
          <form action @submit.prevent="login">
            <div class="form-group">
              <label for="inputEmail">Email</label>
              <input
                type="email"
                class="form-control"
                id="inputEmail"
                placeholder
                value="admin@innovareti.com.br"
                v-model="email"
              >
            </div>
            <div class="form-group mb-5">
              <label for="inputSenha">Senha</label>
              <input
                type="password"
                class="form-control"
                id="inputSenha"
                placeholder
                value="innovareti"
                v-model="password"
              >
              <small id="ajudaSenha" class="form-text text-muted float-right">
                <a href data-toggle="modal" data-target="#modalSenha">Esqueci minha senha</a>
              </small>
            </div>
            <!-- <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="switchLembrar">
              <label class="custom-control-label" for="switchLembrar">Lembrar Senha</label>
            </div> -->
            <button type="submit" class="btn btn-block btn-login">Entrar</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    login() {
      const self = this;
      const api = this.$store.state.api + "customer_login";

      axios
        .post(api, {
          email: self.email,
          password: self.password
        })
        .then(response => {
          self.$store.commit("auth", response.data.access_token);
          self.$router.push({ path: "/" });
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        });
    }
  }
};
</script>

<style>
body {
  font-family: "Roboto", sans-serif;
}
form .form-input {
  width: 90% !important;
  font-size: 15px !important;
  padding: 10px !important;
  border: 1px solid #c0c0c0;
}
form .form-label {
  width: 90% !important;
  display: block;
  text-align: left;
  font-size: 16px !important;
  margin-left: auto;
  margin-right: auto;
}
form .form-button {
  width: 90%;
  padding: 10px;
  font-size: 18px;
  border-radius: 30px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #f0f0f0;
  background: #1197d6 !important;
  color: white;
}

#myModal {
  text-align: left;
}

@media (max-width: 768px) {
  .ibox {
    margin: 0px 0px 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue